import { render, staticRenderFns } from "./MyInsight.vue?vue&type=template&id=48b61807&scoped=true&"
import script from "./MyInsight.vue?vue&type=script&lang=js&"
export * from "./MyInsight.vue?vue&type=script&lang=js&"
import style0 from "./MyInsight.vue?vue&type=style&index=0&id=48b61807&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b61807",
  null
  
)

export default component.exports